export function getNestedValue(messages, key) {
    return key.split(".").reduce((value, part) => {
        if (value == null) {
            return undefined;
        }
        return value[part];
    }, messages);
}

export function interpolate(template, params = {}) {
    if (typeof template !== "string") {
        return template;
    }

    return template.replace(/\{(\w+)\}/g, (_, name) => {
        const value = params[name];
        return value == null ? `{${name}}` : String(value);
    });
}

export function createTranslator(messages) {
    return function translate(key, params) {
        const value = getNestedValue(messages, key);
        if (value == null) {
            return key;
        }
        return interpolate(value, params);
    };
}
